import './utils/cardTypes-cd1fb9a4.js';
import './utils/validator-2883cf27.js';
import './chunk-7eee66c0.js';
import './utils/formatter-aea0ee50.js';
import './utils/index.js';
import 'react';
import usePaymentCard from './usePaymentInputs.js';

function PaymentInputsContainer(props) {
  var paymentInputs = usePaymentCard(props);
  return props.children(paymentInputs);
}

export default PaymentInputsContainer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-payment-inputs/es/PaymentInputsContainer.js
// module id = 958
// module chunks = 0